import { createPinia } from 'pinia'

// Shared Pinia instance
export default createPinia()
